import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: string[];
}

const Select: React.FC<SelectProps> = ({ options, style, ...rest }) => (
  <select
    {...rest}
    style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      color: 'var(--text)',
      borderRadius: 'var(--radius-sm)',
      padding: '5px 10px',
      fontSize: '0.78rem',
      fontFamily: 'var(--font-sans)',
      cursor: 'pointer',
      outline: 'none',
      width: '100%',
      transition: 'border-color var(--transition-fast)',
      ...style,
    }}
  >
    {options.map((opt) => (
      <option key={opt} value={opt}>{opt}</option>
    ))}
  </select>
);

export default Select;
